import { render, staticRenderFns } from "./organ.vue?vue&type=template&id=7c1c0e27&scoped=true&"
import script from "./organ.vue?vue&type=script&lang=js&"
export * from "./organ.vue?vue&type=script&lang=js&"
import style0 from "./organ.vue?vue&type=style&index=0&id=7c1c0e27&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c0e27",
  null
  
)

export default component.exports